import React, { useEffect, useMemo, useState } from 'react';
import { getLogoUrl, normalizeLogoDomain } from 'shared/constants';

interface DomainLogoProps {
  name: string;
  domainOrWebsite?: string | null;
  className?: string;
  fallbackClassName?: string;
}

export const DomainLogo: React.FC<DomainLogoProps> = ({
  name,
  domainOrWebsite,
  className = 'h-10 w-10 rounded object-contain',
  fallbackClassName = 'h-10 w-10 rounded-md bg-blue-100 text-blue-600 flex items-center justify-center text-sm font-bold'
}) => {
  const [imgError, setImgError] = useState(false);
  const normalizedDomain = useMemo(() => normalizeLogoDomain(domainOrWebsite), [domainOrWebsite]);
  const logoSrc = normalizedDomain ? getLogoUrl(normalizedDomain) : undefined;
  const initial = name.trim() ? name.charAt(0).toUpperCase() : '?';

  useEffect(() => {
    setImgError(false);
  }, [logoSrc]);

  if (logoSrc && !imgError) {
    return <img src={logoSrc} alt={name} className={className} onError={() => setImgError(true)} />;
  }

  return <div className={fallbackClassName}>{initial}</div>;
};
